module.exports = __webpack_public_path__ + "static/media/ER.ed8466e0.svg";